<template>
  <DialogWrapper
    close-on-cancel
    class="group-edit-dialog"
    :titleI18nKey="`${i18nPrefix}.title.edit`"
    :show.sync="show"
    :loading="loading"
    @save="handleSave"
  >
    <div class="content">
      <WrappedForm
        class="edit-group-form"
        ref="form"
        hideRequiredAsterisk
        :model="groupInfo"
        :formLines="formLines"
      ></WrappedForm>
    </div>
  </DialogWrapper>
</template>

<script>
import WrappedForm from '@/components/formEditor/wrappedForm.vue'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'

export default {
  components: {
    DialogWrapper,
    WrappedForm
  },
  props: {
    currentGroup: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidateGroup',
      show: false,
      loading: false,
      groupInfo: {}
    }
  },
  computed: {
    formLines () {
      const requiredMessage = this.$t('common.message.requiredFormField')
      const lines = {
        name: {
          label: this.$t(`${this.i18nPrefix}.label.currentGroup`),
          rules: [{ required: true, message: requiredMessage, trigger: 'blur' }]
        }
      }
      return lines
    },
    from () {
      return this.$refs.from
    }
  },
  created () {
  },
  methods: {
    openDialog () {
      this.show = true
    },
    closeDialog () {
      this.show = false
    },
    clearForm () {
      this.groupInfo = {}
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    async handleSave () {
      if (this.loading) {
        return
      }
      const isValid = await this.$refs.form.submit()
      if (!isValid) {
        return
      }
      this.loading = true
      const group = {
        count: this.currentGroup.count,
        text: this.groupInfo.name,
        id: this.currentGroup.id,
        creator: this.currentGroup.creator
      }
      this.$emit('save', group, close => {
        this.loading = false
        if (close) {
          this.closeDialog()
        }
      })
    }
  },
  watch: {
    show () {
      if (this.show) {
        this.clearForm()
        this.groupInfo = { name: this.currentGroup.text }
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.group-edit-dialog {
  .edit-group-form {
    margin-top: 24px;
  }
}
</style>
